import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { getRemainingCharsHintText } from './shared';
import { getRemainingCharsStyles } from './style';

export function withRemainingCharsUnvalidated(WrappedComponent) {
  const RemainingCharsHOC = (props) => {
    const {
      maxLengthHint,
      onChange,
      i18n,
      defaultValue,
    } = props;

    const [value, setValue] = useState(defaultValue);

    const localOnChange = useCallback((event, result) => {
      setValue(result);
      onChange(event, result);
    }, [onChange]);

    const classes = useDefaultStyles(getRemainingCharsStyles);

    const newProps = {
      ...props,
      onChange: localOnChange,
    };

    return (
      <React.Fragment>
        <WrappedComponent {...newProps} />
        <div className={classnames('remaining-chars-container', classes.RemainingCharsContainer)} >
          { getRemainingCharsHintText(value, i18n, maxLengthHint) }
        </div>
      </React.Fragment>
    );
  };

  RemainingCharsHOC.propTypes = {
    i18n: PropTypes.shape({}).isRequired,
    maxLengthHint: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.string,
  };

  RemainingCharsHOC.defaultProps = {
    defaultValue: '',
  };

  RemainingCharsHOC.displayName = `withRemainingCharsUnvalidated(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(RemainingCharsHOC, WrappedComponent);

  return RemainingCharsHOC;
}
